import { gql } from '@apollo/client';

export const DELETE_CERTIFICATE_OVERRIDE_MUTATION = gql`
    mutation deleteCertificateTemplateOverride($input: DeleteCertificateTemplateOverrideInput!) {
        result: deleteCertificateTemplateOverride(input: $input) {
            affectedRows
        }
    } 
`;
